import { render, staticRenderFns } from "./homePage.vue?vue&type=template&id=4f8c5b5d&scoped=true"
import script from "./homePage.vue?vue&type=script&lang=js"
export * from "./homePage.vue?vue&type=script&lang=js"
import style0 from "./homePage.vue?vue&type=style&index=0&id=4f8c5b5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c5b5d",
  null
  
)

export default component.exports